import React from "react";

// Lightweight markdown renderer for AI responses (headings, bold, bullets, line breaks)
export default function MarkdownLite({ text }) {
  if (!text) return null;
  const lines = String(text).split("\n");
  const blocks = [];
  let list = [];

  const flushList = (key) => {
    if (list.length) {
      blocks.push(
        <ul key={`ul-${key}`} className="list-disc pl-5 space-y-1 my-2">
          {list.map((li, i) => <li key={i}>{inline(li)}</li>)}
        </ul>
      );
      list = [];
    }
  };

  lines.forEach((raw, idx) => {
    const line = raw.trimEnd();
    if (/^\s*[-*]\s+/.test(line)) {
      list.push(line.replace(/^\s*[-*]\s+/, ""));
      return;
    }
    flushList(idx);
    if (/^###\s+/.test(line)) blocks.push(<h4 key={idx} className="font-heading font-bold text-gold mt-3 mb-1">{inline(line.replace(/^###\s+/, ""))}</h4>);
    else if (/^##\s+/.test(line)) blocks.push(<h3 key={idx} className="font-heading font-bold text-gold mt-3 mb-1">{inline(line.replace(/^##\s+/, ""))}</h3>);
    else if (/^#\s+/.test(line)) blocks.push(<h3 key={idx} className="font-heading font-bold text-gold mt-3 mb-1">{inline(line.replace(/^#\s+/, ""))}</h3>);
    else if (line.trim() === "") blocks.push(<div key={idx} className="h-1.5" />);
    else blocks.push(<p key={idx} className="my-1">{inline(line)}</p>);
  });
  flushList("end");

  return <div className="text-sm leading-relaxed">{blocks}</div>;
}

function inline(text) {
  const parts = String(text).split(/(\*\*[^*]+\*\*)/g);
  return parts.map((p, i) =>
    /^\*\*[^*]+\*\*$/.test(p) ? <strong key={i} className="font-semibold text-white">{p.slice(2, -2)}</strong> : <span key={i}>{p}</span>
  );
}
